"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PageFilterService_1;
const core_1 = require("@angular/core");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const Subject_1 = require("rxjs/Subject");
let PageFilterService = PageFilterService_1 = class PageFilterService {
    constructor() {
        this.timeout = undefined;
        this.filterChange$ = new Subject_1.Subject();
        this.filterIdMap = new Map();
    }
    setFilter(filterModel) {
        this.filterIdMap.set(filterModel.id, filterModel);
        this.constructDatasetFilterMap();
    }
    removeFilter(id) {
        this.filterIdMap.delete(id);
        this.constructDatasetFilterMap();
    }
    requestPageFilter() {
        this.constructDatasetFilterMap();
    }
    getFilterChange() {
        return this.filterChange$.asObservable();
    }
    getLatestFilterMap() {
        return this.constructDatasetFilterMap(false);
    }
    static getInstance() {
        if (this._instance === undefined) {
            this._instance = new PageFilterService_1();
        }
        return this._instance;
    }
    /**
     * Creates map of dataset ids and corresponding filters
     */
    constructDatasetFilterMap(emitChange = true) {
        let pageFilterMap = new Map();
        Array.from(this.filterIdMap.values())
            .forEach((filter) => {
            if (pageFilterMap.has(filter.pageId)) {
                let datasetFilterMap = pageFilterMap.get(filter.pageId);
                if (datasetFilterMap.get(filter.datasetId)) {
                    let filters = idm_reporting_service_client_js_1.FilterDtoBuilder.and(datasetFilterMap.get(filter.datasetId), filter.filter);
                    datasetFilterMap.set(filter.datasetId, filters);
                }
                else {
                    datasetFilterMap.set(filter.datasetId, filter.filter);
                }
            }
            else {
                pageFilterMap.set(filter.pageId, new Map().set(filter.datasetId, filter.filter));
            }
        });
        emitChange && this.emitFilterChange(pageFilterMap);
        return pageFilterMap;
    }
    emitFilterChange(datasetFilterMap) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.filterChange$.next(datasetFilterMap), 1000);
    }
};
PageFilterService._instance = undefined;
PageFilterService = PageFilterService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], PageFilterService);
exports.PageFilterService = PageFilterService;
//# sourceMappingURL=page-filter.service.js.map